var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loadingSpinner
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loadingSpinner
      ? _c(
          "div",
          [
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  { attrs: { title: "Contacts", active: "" } },
                  [_c("ContactList")],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "Customer Info" } },
                  [_c("b-card", [_c("CustomerInfo")], 1)],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "Quotation" } },
                  [_c("b-card", [_c("Quotation")], 1)],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "Proforma" } },
                  [_c("b-card", [_c("SaleOrder")], 1)],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "Invoices" } },
                  [_c("b-card", [_c("invoice")], 1)],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "Opportunities" } },
                  [_c("Opportunity")],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "Complaints" } },
                  [_c("Complaint")],
                  1
                ),
                _c("b-tab", { attrs: { title: "Note" } }, [_c("ToDo")], 1),
                _c("b-tab", { attrs: { title: "Task" } }, [_c("Task")], 1),
                _c(
                  "b-tab",
                  { attrs: { title: "File Management" } },
                  [_c("FileMgt")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }